module.exports = "<app-area-edit-template on-cancel=$ctrl.cancel() on-save=$ctrl.save() area=$ctrl.area switch-tab-prefix=app.areacreate> </app-area-edit-template> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/area/create/partial.html
// module id = 401
// module chunks = 0